import { render, staticRenderFns } from "./EcoHubTechUserUpdate.vue?vue&type=template&id=6ad22328"
import script from "./EcoHubTechUserUpdate.vue?vue&type=script&lang=js"
export * from "./EcoHubTechUserUpdate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports